import gql from 'graphql-tag';

const provisionDefaultRole = gql`
mutation provisionDefaultRole($role:String!, $roleType:String!) {
  provisionDefaultRole (role:$role, roleType:$roleType) {
    message
  }
}
`;

const getAllRoles = gql`
{allRoles{
  roleIdentifier{
    name,
    team,
    displayName
  },
  permissions{
    action,
    resource,
    allowed
  }
}}
`;

const getPopUsers = gql`
  query($filter: String!, $skip: Int!, $limit: Int!) {
    users(filter: $filter, skip: $skip, limit: $limit) {
      users {
        user_id
        type
        type_id
        timestamp
        auminfo {
          user_login_type_id
          user_name
          first_name
          last_name
          middle_name
          nickname
          preferred_username
          profile_url
          website
          gender
          birthday
          zoneinfo
          locale
          phone_number
          phone_number_verified
          updated_at
          email
          email_validated
          password
          avatar
          number_times_login
          api_version_compatibility
          version
          roles
          last_oauth2_login_info {
            login_time
            user_agent
          }
        }
      }
      skip
      limit
      count
    }
  }
`;

const getAllTeamRoles = gql`
query allTeamRoles($teamID: String!){
  allTeamRoles(teamID: $teamID) {
    roleIdentifier{
      name,
      team,
      displayName
    },
    permissions{
      action,
      resource,
      allowed
    }
  }
}
`;

const TEAM_LIST = gql`
  query($tfilter: String!, $skip: Int!, $limit: Int!) {
    teamList(tfilter: $tfilter, skip: $skip, limit: $limit) {
      teamList {
        team_id
        display_name
      }
      skip
      limit
      count
    }
  }
`;

const SEARCH_TEAMS = gql`
query searchTeams($filter: String!, $skip: Int!, $limit: Int!) {
  searchTeams(filter: $filter, skip: $skip, limit: $limit) {
    team_id
    display_name
  }
}
`;

export {
  provisionDefaultRole,
  getAllRoles,
  getAllTeamRoles,
  getPopUsers,
  TEAM_LIST,
  SEARCH_TEAMS,
};
